import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { MerchantService } from '../merchant.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_services/alert.service';
import { ColDef, GridReadyEvent } from 'ag-grid-community';

@Component({
  selector: 'app-merchant-remark',
  templateUrl: './merchant-remark.component.html',
  styleUrls: ['./merchant-remark.component.scss']
})
export class MerchantRemarkComponent implements OnInit {

  remark : any;
  disabledField : boolean = true;
  permissions :any;
  merchantId : any;
  remarkList : any[];
  pageSize: number = 10;
  public defaultColDef: ColDef = {
    flex: 1,
    resizable: true
  };

  public columnDefs: ColDef[] = [
    {field: 'id', tooltipField: 'id',headerName: 'ID', hide: true},
    {field: 'narration',tooltipField: 'narration', headerName: 'Remark'},
    {field: 'addedBy', headerName: 'Added By'},
    {field: 'addedOn', headerName: 'Added On'},
  ];

  public tableSelectedColumn: ColDef[] = [...this.columnDefs];

  constructor(private router: Router,private menuService: MenusService,private location:Location,private merchantService: MerchantService,private alertService : AlertService, private route: ActivatedRoute) { }

  async ngOnInit(){
    this.merchantId = this.route.snapshot.queryParamMap.get("mid");
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
    this.getRemarkList();
  }
    
  saveRemark(){
    console.log(this.remark);
    if(this.remark != undefined && this.remark != ""){

      let requestForm ={
        "screeningId" : this.merchantId,
        "narration" : this.remark,
        "type" : "KYC_REMARK",
      }
      this.merchantService.saveRemark(requestForm).subscribe((response:any)=>{
        console.log(response);
        if(response.response.message == "Activity Timeline saved successfully"){
          Swal.fire('Remark saved successfully','','success');
          this.remark = "";
          this.getRemarkList();
        }else{
          Swal.fire('Error while saving remark','','error');
        }
      })
    }else{
      Swal.fire('Please enter remark','','error');
    }
  }

  getRemarkList(){
    this.merchantService.getRemarkById(this.merchantId).subscribe((response:any)=>{
      this.remarkList = response.response.data;
      this.remarkList = this.remarkList.sort((a, b) => {
        return Date.parse(b.addedOn.replace(' ', 'T')) - Date.parse(a.addedOn.replace(' ', 'T'));
      });
    })
  }

}
